// extracted by mini-css-extract-plugin
export var darkMode = "_2-0";